import { render } from "./Chapter2.vue?vue&type=template&id=2f1d7b24&scoped=true"
import script from "./Chapter2.vue?vue&type=script&lang=js"
export * from "./Chapter2.vue?vue&type=script&lang=js"

import "./Chapter2.vue?vue&type=style&index=0&id=2f1d7b24&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1d7b24"]])

export default __exports__